import $ from 'jquery';

class Products {
  constructor() {
    this.layout = $('.js-product-layout');
    this.products = $('.products');

    this.setLayout();
  }

  setLayout() {
    if (this.layout.length && this.products.length) {
      this.layout.on('click', e => {
        const self = $(e.currentTarget);
        const layout = self.data('layout');

        this.products.removeClass('is-grid is-list').addClass(`is-${layout}`);
        this.layout.removeClass('is-active');
        self.addClass('is-active');
      });
    }
  }
}

export default new Products();



// WEBPACK FOOTER //
// ./src/scripts/modules/products.js